export default "__VITE_ASSET__DDgOszCs__"